// Generated by scripts/generateSitemap.ts.
// Contains public SEO landing page fields only for approved, published search docs.
export const PUBLIC_SEARCH_LANDING_SEO_TARGET = {"projectId":"soko-grid","frontendProjectId":"soko-grid","storageBucket":"soko-grid.firebasestorage.app","functionsRegion":"africa-south1"} as const;
export const PUBLIC_SEARCH_LANDING_SEO = [
  {
    "slug": "bakeries-and-snacks-shops-in-cbd",
    "queryLabel": "Bakeries & Snacks Shops",
    "locationLabel": "CBD",
    "businesses": [
      {
        "name": "Sample Business",
        "slug": "sample-business",
        "description": "We make fresh custom cakes for birthdays, weddings, graduations, baby showers, and special events. We also offer cupcakes, pastries, snacks, and dessert treats.",
        "categoryName": "Food, Drink & Hospitality",
        "subcategoryName": "Bakeries & Snacks Shops",
        "countyName": "Nairobi",
        "cityName": "Nairobi",
        "areaName": "CBD",
        "logoUrl": "https://firebasestorage.googleapis.com/v0/b/soko-grid.firebasestorage.app/o/businesses%2Ff1bugXeqFaPQzWhmuOqq%2Fbrand%2Fprofile-1780644116681.jpg?alt=media&token=f338b88d-91d2-4d69-a331-cc90198d430e",
        "itemNames": []
      }
    ]
  },
  {
    "slug": "bouncing-castle-and-popcorn-planet-in-kikuyu",
    "queryLabel": "Bouncing Castle & Popcorn Planet",
    "locationLabel": "Kikuyu",
    "businesses": [
      {
        "name": "Babbles inflatable",
        "slug": "babbles-inflatable",
        "description": "We specialize in hiring and sales of bouncing castle, popcorn and candy floss machines. Also offer Event planning services.",
        "categoryName": "Events & Parties",
        "subcategoryName": "Bouncing Castle & Popcorn Planet",
        "countyName": "Kiambu",
        "cityName": "Kikuyu",
        "areaName": "Sigona",
        "logoUrl": "https://firebasestorage.googleapis.com/v0/b/soko-grid.firebasestorage.app/o/businesses%2FkURbtgGT0eBQroddixoE%2Fbrand%2Fprofile-1781165916915.jpg?alt=media&token=204af5ea-4ed6-40fd-8e7e-632ef2c5cccf",
        "itemNames": []
      }
    ]
  },
  {
    "slug": "bouncing-castle-and-popcorn-planet-in-sigona",
    "queryLabel": "Bouncing Castle & Popcorn Planet",
    "locationLabel": "Sigona",
    "businesses": [
      {
        "name": "Babbles inflatable",
        "slug": "babbles-inflatable",
        "description": "We specialize in hiring and sales of bouncing castle, popcorn and candy floss machines. Also offer Event planning services.",
        "categoryName": "Events & Parties",
        "subcategoryName": "Bouncing Castle & Popcorn Planet",
        "countyName": "Kiambu",
        "cityName": "Kikuyu",
        "areaName": "Sigona",
        "logoUrl": "https://firebasestorage.googleapis.com/v0/b/soko-grid.firebasestorage.app/o/businesses%2FkURbtgGT0eBQroddixoE%2Fbrand%2Fprofile-1781165916915.jpg?alt=media&token=204af5ea-4ed6-40fd-8e7e-632ef2c5cccf",
        "itemNames": []
      }
    ]
  },
  {
    "slug": "land-and-plots-in-kikuyu",
    "queryLabel": "Land & Plots",
    "locationLabel": "Kikuyu",
    "businesses": [
      {
        "name": "Kluger Properties",
        "slug": "kluger-properties",
        "description": "Kluger Properties offers trusted land and plot for sale services in Kikuyu and surrounding areas. We help buyers find suitable residential and investment plots with clear information, reliable guidance, and convenient viewing support. We assist with plot verification, title deed search and property checks.",
        "categoryName": "Real Estate & Property",
        "subcategoryName": "Land & Plots",
        "countyName": "Kiambu",
        "cityName": "Kikuyu",
        "areaName": "Sigona",
        "logoUrl": "https://firebasestorage.googleapis.com/v0/b/soko-grid.firebasestorage.app/o/businesses%2FFibaLxW59kcfU6SiIqkN%2Fbrand%2Fprofile-1780748592207.jpg?alt=media&token=5d7a8a82-8a76-4310-aa22-d2ad1b0378f1",
        "itemNames": []
      }
    ]
  },
  {
    "slug": "land-and-plots-in-sigona",
    "queryLabel": "Land & Plots",
    "locationLabel": "Sigona",
    "businesses": [
      {
        "name": "Kluger Properties",
        "slug": "kluger-properties",
        "description": "Kluger Properties offers trusted land and plot for sale services in Kikuyu and surrounding areas. We help buyers find suitable residential and investment plots with clear information, reliable guidance, and convenient viewing support. We assist with plot verification, title deed search and property checks.",
        "categoryName": "Real Estate & Property",
        "subcategoryName": "Land & Plots",
        "countyName": "Kiambu",
        "cityName": "Kikuyu",
        "areaName": "Sigona",
        "logoUrl": "https://firebasestorage.googleapis.com/v0/b/soko-grid.firebasestorage.app/o/businesses%2FFibaLxW59kcfU6SiIqkN%2Fbrand%2Fprofile-1780748592207.jpg?alt=media&token=5d7a8a82-8a76-4310-aa22-d2ad1b0378f1",
        "itemNames": []
      }
    ]
  }
] satisfies Record<string, unknown>[];
export const PUBLIC_SEARCH_LANDING_SEO_SHA256 = "c36ff173abe92f0fe4d6b52dcb08957b4038a0baa5e5ebd0c238adcd3e5f37e4" as const;
